import { useGetMedicationsPendingSignOffsQuery } from "../../../services/api/medicationsApi";

interface Props {
  currentPage: number;
}

export function useHandleMedicationsPendingSignOffs({ currentPage }: Props) {
  const { data, isLoading } = useGetMedicationsPendingSignOffsQuery({
    page: currentPage,
  });

  return { data, isLoading };
}
